import React, {PureComponent} from "react";
import {connect} from "react-redux";
import {fileDelete} from "../../../../../core/actions/FileActions";
import {Field, formValueSelector} from "redux-form";
import {getDeadlineItem} from "../../../helpers/DeadlineHelper";
import {
    FILE_STATUS_ERROR,
    FILE_STATUS_UPLOADING, URL_STATUS_ERROR
} from "../../../../../core/constants/FileStatusConstant";
import InputField from "../../../../../core/components/forms/InputField";
import {requiredFiles, maxFiles} from "../Validation";
import {Trans, withTranslation} from "react-i18next";
import {DurationConverter} from "../../../../../core/helpers/TimeHelper";
import UploadingFileAction from "../../../../../core/components/table/action/UploadingFileAction";
import DeleteUploadedFileAction from "../../../../../core/components/table/action/DeleteUploadedFileAction";
import DeleteNotUploadedFileAction from "../../../../../core/components/table/action/DeleteNotUploadedFileAction";
import ModalButton from "../../../../../core/components/modals/ModalButton";

class UploadedFilesList extends PureComponent {

    handleDeleteFile = file => {
        const {fileDelete} = this.props;
        fileDelete(file);
    };

    renderDeadline = file => {
        const {deadlines, selectedService} = this.props;
        const deadline = getDeadlineItem(selectedService, deadlines, file);

        return deadline ? deadline.name : '-';
    };

    renderTable = () => {
        const {files, t} = this.props;

        return <table>
            <thead>
            <tr>
                <th><Trans>Name</Trans></th>
                <th className="mobile-hidden"><Trans>Duration</Trans></th>
                <th><Trans>Deadline</Trans> <span className="info-holder">info <span className="popup">The time in which you will receive your completed transcription.</span></span>
                </th>
                <th />
            </tr>
            </thead>
            <tbody>
            {files.map(file => (
                <tr key={file.uid}>
                    <td>
                        <span className="file-name" title={file.originalName}>{file.originalName}</span>
                        <span className="mobile-visible"><Trans>Duration</Trans>: {DurationConverter(file.duration)}</span>
                        {
                            file.status === FILE_STATUS_ERROR
                            && <span className="error">{t(file.message)}</span>
                        }
                        {
                            file.status === URL_STATUS_ERROR
                            && <span className="error">{t(file.message)}
                                <ModalButton id="instruction-modal-component" className="btn green">Use The Instruction</ModalButton>
                            </span>
                        }
                    </td>
                    <td className="mobile-hidden">{DurationConverter(file.duration)}</td>
                    <td>
                        <div className="holder">
                            <span className="duration">{this.renderDeadline(file)}</span>
                        </div>
                    </td>
                    <td>
                        <UploadingFileAction file={file} statuses={[FILE_STATUS_UPLOADING]} />
                        <DeleteUploadedFileAction file={file} />
                        <DeleteNotUploadedFileAction file={file} />
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    };

    render() {
        const {files} = this.props;

        return <div className="table-holder">
            {files.length ? this.renderTable() : null}
            <Field
                name="files"
                component={InputField}
                type="hidden"
                validate={[requiredFiles, maxFiles]}
            />
        </div>;
    }
}

UploadedFilesList = withTranslation()(UploadedFilesList)

const selector = formValueSelector('OrderForm');

export default connect(
    state => ({
        files: state.file.files,
        deadlines: state.dictionary.deadline,
        selectedService: selector(state, 'service')
    }),
    dispatch => ({
        fileDelete: fileData => dispatch(fileDelete(fileData)),
    })
)(UploadedFilesList);